<template>
  <div>
    <div class="next-back">
      <router-link to="/speisen">Weiter</router-link>
    </div>
    <h2>Buffetvariationen</h2>
    <div>
      <p v-html="getCategoryDescription('buffetvariationen')"></p>
    </div>
    <div class="kdz-buffet-variation-container">
      <div
        class="kdz-buffet-variation"
        v-for="menu in buffetCategories"
        :key="menu.id"
      >
        <h3 v-html="menu.name"></h3>
        <div class="kdz-buffet-content row">
          <div :class="['kdz-buffet-image', {'col-md-3': menu.image !== false}]">
            <img :src="menu.image ? menu.image : ''" width="100%"/>
          </div>
          <div class="col-12 col-md-9">
            <p v-html="menu.description"></p>
            <button
              class="kdz-select-buffet-button"
              @click="selectBuffet(menu.slug)"
            >
              auswählen
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "Start",
  computed: {
    ...mapGetters([
      "getSubCategoriesByCategoryName",
      "getCategoryDescription",
      "getCateringItemsByCategorySlug",
      "getSelection",
    ]),
    buffetCategories() {
      return this.getSubCategoriesByCategoryName("Buffetvariationen");
    },
  },
  methods: {
    ...mapMutations(["setSelection"]),
    selectBuffet(buffetSlug) {
      const slug = buffetSlug.replaceAll("_", "-");
      let items = this.getCateringItemsByCategorySlug(slug);
      let selected = Object.assign({}, this.getSelection);
      items.forEach((el) => (selected[el.slug.replaceAll("-", "_")] = true));
      this.setSelection(selected);
      this.$router.push("speisen");
    },
  },
};
</script>

<style lang="scss" scoped>
.next-back {
  justify-content: flex-end;
}
.kdz-buffet-variation {
  width: 100%;
  padding: 10px;
}
.kdz-buffet-variation-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

.kdz-select-buffet-button {
  font-weight: bold;
  color: #ececec;
  text-decoration: none;
  font-size: 18px;
  background-color: #7f9b5b;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  &:hover {
    background-color: #586c3f;
  }
}

@media screen and (min-width: 578px) {
  .kdz-buffet-variation{
    width: 45%;
  }
}

</style>
